var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "home-container" },
        [
          _c(
            "div",
            { staticClass: "hx-breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { "separator-class": "el-icon-arrow-right" } },
                [
                  _c("el-breadcrumb-item", [_vm._v("首页")]),
                  _c("el-breadcrumb-item", [_vm._v("供应系统")]),
                  _c("el-breadcrumb-item", [_vm._v("基地管理")]),
                  _c("el-breadcrumb-item", [_vm._v("供应力上报")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "hx-form-container box-shadow" },
            [
              _c(
                "el-form",
                {
                  ref: "listForm",
                  attrs: {
                    rules: _vm.checkListParams,
                    model: _vm.listParams,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "领货日期：", prop: "dateId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择领货日期",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.listParams.dateId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listParams, "dateId", $$v)
                                    },
                                    expression: "listParams.dateId",
                                  },
                                },
                                _vm._l(_vm.dateList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      value: item.id,
                                      label: item.title,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.loadColumnTitle("listForm")
                                    },
                                  },
                                },
                                [_vm._v(" 查询 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c(
                  "div",
                  { staticStyle: { position: "absolute", right: "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !this.listParams.dateId,
                          size: "small",
                          type: "primary",
                        },
                        on: { click: _vm.loadTemplate },
                      },
                      [_vm._v(" 上菜模板 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !this.listParams.dateId,
                          size: "small",
                        },
                        on: { click: _vm.resetTableData },
                      },
                      [_vm._v(" 重置 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.isDisabled || !this.listParams.dateId,
                          type: "success",
                          size: "small",
                        },
                        on: { click: _vm.saveToDraft },
                      },
                      [_vm._v(" 保存为草稿 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.isDisabled || !this.listParams.dateId,
                          type: "primary",
                          size: "small",
                        },
                        on: {
                          click: function ($event) {
                            _vm.dialogVisible = true
                          },
                        },
                      },
                      [_vm._v(" 保存并提交 ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "text" },
                        on: { click: _vm.linkToRecordPage },
                      },
                      [_vm._v(" 历史记录 ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _c(
            "hx-table-result",
            {
              attrs: {
                "show-pager-on-one-page": false,
                "page-info": _vm.pager,
                loading: _vm.tableLoading,
              },
              on: {
                "page-current-change": _vm.handleCurrentChange,
                "page-size-change": _vm.handleSizeChange,
              },
            },
            [
              _c("div", { attrs: { slot: "action" }, slot: "action" }),
              _c(
                "el-table",
                {
                  attrs: {
                    slot: "content",
                    data: _vm.tableData,
                    "max-height": "800",
                    border: "",
                  },
                  slot: "content",
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      fixed: "",
                      align: "center",
                      width: "60",
                      label: "序号",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  (_vm.pager.pageIndex > 1
                                    ? (_vm.pager.pageIndex - 1) *
                                      _vm.pager.pageSize
                                    : 0) +
                                    scope.$index +
                                    1
                                ),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      align: "center",
                      fixed: "",
                      label: "产品名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "spec",
                      align: "center",
                      fixed: "",
                      label: "规格",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "little",
                      align: "center",
                      label: "基地供应能力",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "little",
                      align: "center",
                      label: "基地上报量",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { size: "small" },
                              on: {
                                change: function ($event) {
                                  return _vm.reset($event, scope.$index)
                                },
                              },
                              model: {
                                value: scope.row.little,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "little",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.little",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._l(_vm.columnList, function (item, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: { align: "center", label: item.logisticName },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.showSuplly(
                                  _vm.columnList[index].plaLogisticSiteId,
                                  scope.row.stockProportionList,
                                  index,
                                  scope.$index
                                )
                                  ? _c("el-input", {
                                      attrs: { size: "small" },
                                      model: {
                                        value: scope.row.list[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row.list,
                                            index,
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "scope.row.list[index]",
                                      },
                                    })
                                  : _c("span", [_vm._v("0")]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-login-out-template",
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("h3", { staticClass: "align-center" }, [
            _vm._v("确定提交供应能力上报？"),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.isDisabled,
                    size: "small",
                    type: "primary",
                  },
                  on: { click: _vm.saveAndSubmit },
                },
                [_vm._v(" 确 定 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(" 取 消 ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-login-out-template",
          attrs: {
            title: "上菜模板",
            visible: _vm.templateVisible,
            width: "50%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.templateVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.templateLoading,
                  expression: "templateLoading",
                },
              ],
              ref: "templateForm",
              staticStyle: { padding: "10px 20px" },
              attrs: { model: _vm.templateParams, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜品名称：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            filterable: "",
                            clearable: "",
                            remote: "",
                            "reserve-keyword": "",
                            placeholder: "请输入菜品名称",
                            "remote-method": _vm.remoteMethod,
                            loading: _vm.dishesLoading,
                          },
                          on: { change: _vm.dishChanged },
                          model: {
                            value: _vm.templateParams.dishId,
                            callback: function ($$v) {
                              _vm.$set(_vm.templateParams, "dishId", $$v)
                            },
                            expression: "templateParams.dishId",
                          },
                        },
                        _vm._l(_vm.dishesList, function (item) {
                          return _c("el-option", {
                            key: item.title,
                            attrs: { label: item.title, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    _vm._l(_vm.categoryNameList, function (item, index) {
                      return _c("div", { key: index }, [
                        _c("div", { staticClass: "e-tag-div-style" }, [
                          _c("span", { staticClass: "e-tag-title" }, [
                            _vm._v(_vm._s(item.title) + "："),
                          ]),
                          _c(
                            "ul",
                            { staticClass: "e-tag-ul-style" },
                            _vm._l(
                              _vm.dishes["categoryList_" + index],
                              function (item1, index1) {
                                return _c(
                                  "li",
                                  {
                                    key: index1,
                                    staticClass:
                                      "e-tag-inline e-tag e-tag-info e-tag-mini",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-tag-item-text" },
                                      [_vm._v(_vm._s(item1.title))]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "e-tag-item-close el-icon-circle-close",
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteItem(
                                            _vm.dishes["categoryList_" + index],
                                            index1,
                                            index
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        disabled: _vm.templateBtnDisabled,
                      },
                      on: { click: _vm.createTemplate },
                    },
                    [_vm._v(" 生成模板 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.templateVisible = false
                        },
                      },
                    },
                    [_vm._v(" 取消 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }